<!-- Desktop/Tablet: Sticky Patient Context Header -->
@if (!isHandset()) {
  <header class="patient-header" role="banner">
    <div class="patient-header__top-row">
      <button mat-icon-button
              class="patient-header__back-btn"
              (click)="navigateBack()"
              aria-label="戻る"
              i18n-aria-label="@@home.userDetailLayout.back.ariaLabel">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <span class="patient-header__back-label"
            (click)="navigateBack()"
            role="button"
            tabindex="0"
            (keydown.enter)="navigateBack()"
            (keydown.space)="navigateBack(); $event.preventDefault()">{{ backLabel() }}</span>

      @if (currentUser(); as user) {
        <div class="patient-header__info">
          <span class="patient-header__name">{{ user.name }}</span>
          <div class="patient-header__meta">
            <span class="patient-header__badge"
                  [class.patient-header__badge--male]="user.sex === 'male'"
                  [class.patient-header__badge--female]="user.sex === 'female'">
              {{ user.sex | sexLang : sexLanguage }}
            </span>
            <span class="patient-header__detail">{{ formatAge(user.birthDate | calculateAge) }}</span>
            @if (user.birthDate) {
              <span class="patient-header__separator">·</span>
              <span class="patient-header__detail patient-header__birthdate">{{ user.birthDate | date:'mediumDate' }}</span>
            }
          </div>
        </div>
      }
    </div>

    <!-- Feature tabs -->
    @if (displayedFeatures().length > 0) {
      <nav class="patient-header__tabs" role="tablist" [attr.aria-label]="detailNavAriaLabel">
        @for (feature of displayedFeatures(); track feature) {
          <a class="patient-header__tab"
             [routerLink]="getFeatureRoute(feature)"
             routerLinkActive="patient-header__tab--active"
             [routerLinkActiveOptions]="{ exact: false }"
             role="tab">
            <mat-icon class="patient-header__tab-icon">{{ getFeatureIcon(feature) }}</mat-icon>
            <span>{{ getFeatureLabel(feature) }}</span>
          </a>

          @if (feature === 'GOST' && isGostSectionRoute()) {
            <div class="patient-header__gost-subtabs-inline"
                 role="group"
                 [attr.aria-label]="gostSubmenuAriaLabel">
              @for (tab of gostHeaderTabs; track tab.path) {
                <a class="patient-header__gost-subtab"
                   [routerLink]="getGostHeaderRoute(tab.path)"
                   [class.patient-header__gost-subtab--active]="isGostHeaderTabActive(tab.path)"
                   role="tab">
                  <span>{{ tab.label }}</span>
                </a>
              }
            </div>
          }
        }
      </nav>
    }
  </header>
}

<!-- Mobile: M3 Fixed Header + Bottom Tab Bar -->
@if (isHandset() && currentUser(); as user) {
  <header class="m3-header">
    <button class="m3-header__back" mat-icon-button (click)="navigateBack()">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="m3-header__content">
      <div class="m3-header__name-row">
        <span class="m3-header__name">{{ user.userName }}</span>
      </div>
      <div class="m3-header__meta-row">
        <span class="m3-header__badge"
              [class.m3-header__badge--male]="user.sex === 'male'"
              [class.m3-header__badge--female]="user.sex === 'female'">
          {{ user.sex | sexLang : sexLanguage }}
        </span>
        <span class="m3-header__meta">{{ formatAge(user.birthDate | calculateAge) }}</span>
        @if (user.birthDate) {
          <span class="m3-header__separator">·</span>
          <span class="m3-header__meta m3-header__birthdate">{{ user.birthDate | date:'mediumDate' }}</span>
        }
      </div>
    </div>
  </header>
  <div class="m3-header-spacer"></div>

  <!-- M3 Bottom Tab Bar -->
  <nav class="m3-tabs" role="tablist" [attr.aria-label]="detailNavAriaLabel">
    @for (feature of displayedFeatures(); track feature) {
      <a class="m3-tabs__tab"
         [routerLink]="getFeatureRoute(feature)"
         routerLinkActive="m3-tabs__tab--active"
         role="tab">
        <mat-icon>{{ getFeatureIcon(feature) }}</mat-icon>
        <span>{{ getFeatureLabel(feature) }}</span>
      </a>
    }
  </nav>
}

<!-- Child page content -->
<div class="patient-content">
  <router-outlet />
</div>

<!-- Popup window for expert dialog (persists across record navigation) -->
@if (popupWindowState.visible()) {
  <app-popup-window />
}
